const $ = jQuery.noConflict();

class PropelCalendar {
	constructor() {
		this.calendarContainer = $('.propel-calendar');
		this.eventCells = this.calendarContainer.find('.event');
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.eventCells.on('click', this.showEvents);
	}
	showEvents(e) {

		let monthYear = $(this)
			.closest('.propel-calendar__month')
			.find('.month-year')
			.text();
		monthYear = monthYear.split(' ', 2);

		let daySelected = $(this).parent().html();
		daySelected = daySelected.replace( '<time>', '<time>' + monthYear[0] + ' ' );
		daySelected = daySelected.replace( '</time>', ', ' + monthYear[1] + '</time>' );

		const detailsContainer = $(this)
			.closest('.propel-calendar__month')
			.find('.day-selected');

		detailsContainer.html(daySelected);
	}
}

const newCalendar = new PropelCalendar();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newCalendar.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
